import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  removeAllRegionProducts,
  removeRegionProduct,
} from "../services/region-products";

export function useRemoveRegionProduct() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      regionId,
      productId,
    }: {
      regionId: string;
      productId: string;
    }) => removeRegionProduct(regionId, productId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["bundles"] }),
  });
}

export function useRemoveAllRegionProducts() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (regionId: string) => removeAllRegionProducts(regionId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["bundles"] }),
  });
}
